export default __webpack_public_path__ + "static/media/thumb_small.ae41eb0c.jpg";